import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from '../config/config';
import { Lote } from '../models/lote';

@Injectable({
  providedIn: 'root'
})
export class LoteService {

  constructor(
    public http: HttpClient
  ) { }


 


  crearlote( loteguarda: Lote ) {
    let url = URL_SERVICIOS + '/lote';
    return this.http.post <any> ( url , loteguarda);
    
  }

 


  muestralote( idprecompra: string  ) {
    let url = URL_SERVICIOS + '/lote/' + idprecompra;
    return this.http.get <any> ( url);
    
  }


  muestrainventario() {
    let url = URL_SERVICIOS + '/inventariolote';
    return this.http.get <any> ( url);
    
  }

  muestraloteempresa( idempresa: string ) {
    let url = URL_SERVICIOS + '/lote/empresa/' + idempresa ;
    return this.http.get <any> ( url);
    
  }



  muestralotelanding( idempresa: string, selecciontipo: string ) {
    let url = URL_SERVICIOS + '/lote/empresaloteslanding/' + idempresa +'/' + selecciontipo;
    return this.http.get <any> ( url);
    
  }


  muestraloteempresagencia( idempresa: string, tlicencia: string ) {
    let url = URL_SERVICIOS + '/lote/empresagencia/' + idempresa + "/" + tlicencia  ;
    return this.http.get <any> ( url);
    
  }

  muestraloteempresabots( idempresa: string , loteasiganado: number ) {
    let url = URL_SERVICIOS + '/lote/empresabotuser/' + idempresa +"/" + loteasiganado;
    return this.http.get <any> ( url);
    
  }


  muestraloteempresavarios( tipo: string  ) {
    let url = URL_SERVICIOS + '/lote/variostipos/' + tipo;
    return this.http.get <any> ( url);
    
  }


  marcaloteinhabilitado( valor : boolean, id  ) {
    let url = URL_SERVICIOS + '/lote/' +id;
    return this.http.put ( url,valor);
    
  }


  actualizalotedisponible(  loteseleccion ) {
    let url = URL_SERVICIOS + '/lote/disponiblelote/' + loteseleccion._id ;
    return this.http.put ( url,loteseleccion);
    
  }

}
